import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAccountExtraData } from './fetchAccountExtraData.thunks';
import { RootState } from '../rootReducer';

export interface IAccountExtraDataItem {
  internalId: string;
  label: string;
}

export interface IAccountExtraData {
  industries: IAccountExtraDataItem[];
  sizes: IAccountExtraDataItem[];
  roles: IAccountExtraDataItem[];
}

export interface IAccountExtraDataState extends IAccountExtraData {
  loading: boolean;
}

export const initialState: IAccountExtraDataState = {
  industries: [],
  sizes: [],
  roles: [],
  loading: false
};

export const selectAccountExtraDataIndustries = (state: RootState): IAccountExtraDataItem[] => state.accounts.accountExtraData.industries;
export const selectAccountExtraDataSizes = (state: RootState): IAccountExtraDataItem[] => state.accounts.accountExtraData.sizes;
export const selectAccountExtraDataRoles = (state: RootState): IAccountExtraDataItem[] => state.accounts.accountExtraData.roles;
export const selectAccountExtraLoading = (state: RootState): boolean => state.accounts.accountExtraData.loading;

const fetchAccountExtraDataSlices = createSlice({
  name: 'accountExtraData',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAccountExtraData?.pending.type]: (state: IAccountExtraDataState) => {
      state.loading = true;
      state.industries = initialState.industries;
      state.sizes = initialState.sizes;
      state.roles = initialState.roles;
    },
    [fetchAccountExtraData?.fulfilled.type]: (state: IAccountExtraDataState, action: PayloadAction<IAccountExtraData>) => {
      const { industries = [], sizes = [], roles = [] } = action.payload;
      state.loading = false;
      state.industries = [...industries];
      state.sizes = [...sizes];
      state.roles = [...roles];
    },
    [fetchAccountExtraData?.rejected.type]: (state: IAccountExtraDataState) => {
      state.loading = false;
      state.industries = initialState.industries;
      state.sizes = initialState.sizes;
      state.roles = initialState.roles;
    }
  }
});

export default fetchAccountExtraDataSlices.reducer;
